"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var components_1 = require("components");
var react_redux_1 = require("react-redux");
var react_intl_1 = require("react-intl");
var utils_1 = require("../utils");
var libzl_1 = require("../libzl");
var Dialog = styled_components_1.default(components_1.MessageDialog)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", ";\n\n\t&>div:last-child {\n\t\tpadding: 63px 102px 47px;\n\t}\n\n\t@media not ", " {\n\t\tmin-width: 500px;\n\t}\n\n\t/* hacky way to get this specific dialog to match spec*/\n\t@media ", "{\n\t\tjustify-content: start;\n\t\t&>div:first-child{\n\t\t\tpadding: 50px 50% 30px 11px;\n\t\t\ttext-align: left;\n\t\t\tflex: 1;\n\t\t}\n\t\t&>div:nth-child(2){\n\t\t\tflex: 2;\n\t\t}\n\t\t&>div:last-child {\n\t\t\tpadding: 0px 35px 42px 35px;\n\t\t}\n\t\t\n\t}\n\t\n"], ["\n\t", ";\n\n\t&>div:last-child {\n\t\tpadding: 63px 102px 47px;\n\t}\n\n\t@media not ", " {\n\t\tmin-width: 500px;\n\t}\n\n\t/* hacky way to get this specific dialog to match spec*/\n\t@media ", "{\n\t\tjustify-content: start;\n\t\t&>div:first-child{\n\t\t\tpadding: 50px 50% 30px 11px;\n\t\t\ttext-align: left;\n\t\t\tflex: 1;\n\t\t}\n\t\t&>div:nth-child(2){\n\t\t\tflex: 2;\n\t\t}\n\t\t&>div:last-child {\n\t\t\tpadding: 0px 35px 42px 35px;\n\t\t}\n\t\t\n\t}\n\t\n"])), function (props) { return props.theme.shareDialog; }, function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.S; });
var SocialButton = styled_components_1.default(components_1.IconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\t", ";\n\n\tpadding: 0;\n\twidth: 108px;\n\theight: 108px;\n\tmargin: 0px 11.5px;\n\n\t@media ", "{\n\t\twidth: 98px;\n\t\theight: 98px;\n\t\tmargin: 0px 15px;\n\t}\n\n\tsvg{\n\t\twidth: 100%;\n\t}\n"], ["\n\t", ";\n\n\tpadding: 0;\n\twidth: 108px;\n\theight: 108px;\n\tmargin: 0px 11.5px;\n\n\t@media ", "{\n\t\twidth: 98px;\n\t\theight: 98px;\n\t\tmargin: 0px 15px;\n\t}\n\n\tsvg{\n\t\twidth: 100%;\n\t}\n"])), function (props) { return props.theme.socialButton; }, function (props) { return props.theme.breakpoints.S; });
var ContentDiv = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 100%;\n\tflex-direction: column;\n\t\n\t@media ", " {\n\t\ttext-align: center;\n\t\tflex-grow: 1;\n\t}\n\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\theight: 100%;\n\tflex-direction: column;\n\t\n\t@media ", " {\n\t\ttext-align: center;\n\t\tflex-grow: 1;\n\t}\n\n"])), function (props) { return props.theme.breakpoints.S; });
var ButtonMargin = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.buttonMargin; });
var ShareInput = styled_components_1.default.input(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\t", ";\n\twidth: 60%;\n"], ["\n\t", ";\n\twidth: 60%;\n"])), function (props) { return props.theme.shareInput; });
var ShareDialog = /** @class */ (function (_super) {
    __extends(ShareDialog, _super);
    function ShareDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.copyLink = function () {
            console.log("Need a URL to copy here.");
            _this.props.onClose();
        };
        _this.getURL = function () {
            return utils_1.getDirectURL(_this.props.shortcode);
        };
        _this.shareFacebook = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.share("facebook")];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.shareTwitter = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.share("twitter")];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.shareInstagram = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.share("instagram")];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.shareEmail = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.share("email")];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.share = function (channel) { return __awaiter(_this, void 0, void 0, function () {
            var image;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        image = this.props.screenshot;
                        if (!!image) return [3 /*break*/, 2];
                        return [4 /*yield*/, libzl_1.getHeroShot(this.props.buildSession, this.props.environment, 512, 512)];
                    case 1:
                        image = _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.props.buildSession.share(channel, image, true)];
                    case 3:
                        _a.sent();
                        if (this.props.onClose) {
                            this.props.onClose();
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        _this.copyToClipBoard = function () {
            var url = _this.getURL();
            if (url) {
                if (utils_1.copyTextToClipboard(url)) {
                    console.log("Copied URL to clipboard", url);
                }
                if (_this.props.onClose) {
                    _this.props.onClose();
                }
            }
        };
        return _this;
    }
    ShareDialog.prototype.render = function () {
        var _this = this;
        var s = function (id, defaultStr, params) {
            return utils_1.formatMessage(_this.props.intl, { id: id, defaultMessage: defaultStr ? defaultStr : id }, params ? params : {});
        };
        var icons = this.props.theme.svgs;
        var title = this.props.screenshot ? s("sharedialog.title_screenshot", "Share Screenshot") : s("sharedialog.title", "Share");
        var copy = s("sharedialog.copy", "Copy link");
        var close = s("general.close", "Close");
        return (react_1.default.createElement(Dialog, { title: title, onClose: this.props.onClose, closeTooltip: close },
            react_1.default.createElement(ContentDiv, null,
                react_1.default.createElement("div", { style: { display: "inline-flex", flexFlow: "row wrap", alignItems: "center", justifyContent: "center", paddingBottom: "27px" } },
                    react_1.default.createElement("div", { style: { whiteSpace: "nowrap" } },
                        react_1.default.createElement(SocialButton, { icon: icons.Facebook, onClick: this.shareFacebook }),
                        react_1.default.createElement(SocialButton, { icon: icons.Twitter, onClick: this.shareTwitter })),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(SocialButton, { icon: icons.Email, onClick: this.shareEmail }))),
                !this.props.screenshot &&
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement(ShareInput, { defaultValue: this.getURL(), disabled: true }),
                        react_1.default.createElement(ButtonMargin, null,
                            react_1.default.createElement(components_1.LinkButton, { text: copy, onClick: this.copyToClipBoard, automationId: "copylink" }))))));
    };
    return ShareDialog;
}(react_1.Component));
var MapStoreToProps = function (store /*, ownProps:any*/) {
    return {
        buildSession: store.BuildSession.current,
        shortcode: store.BuildSession.shortcode,
        environment: store.UI.environments.current
    };
};
exports.default = react_redux_1.connect(MapStoreToProps)(styled_components_1.withTheme(react_intl_1.injectIntl(ShareDialog)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=ShareDialog.js.map